import { useWeb3React } from "@web3-react/core";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { WalletLinkConnector } from "@web3-react/walletlink-connector";
import { Button, Col, Divider, Modal, Row, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { ConnectorError } from "@web3-react/core";
import styles from "./Nav.module.css";
import dark from "./NavDark.module.css";
import Eth from "../../util/Svg/Eth";
import Wallet from "../../util/Svg/Wallet";
import { connectors } from "../../util/connector";
import { Buffer } from "buffer";
const ConnectWallet = ({theme}) => {
    window.Buffer = window.Buffer || Buffer;
  const [error, setError] = useState(null);
  const [isVisible, setisVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [networkName, setNetworkName] = useState();
  const errorMsg = (error) => {
    Modal.error({
      title: "Error",
      content: error,
    });
  };
  const errorMsg2 = () => {
    Modal.error({
      title: "Please login with mainnet",
      content: "You are using goreli please use mainet",
    });
  };
  //   const enableEthereum = async () => {
  //     // const { loading, error, data, fetchData } = useAxios();
  //     setLoading(true);

  //     if (window.ethereum) {
  //       try {
  //         await window.ethereum.enable();
  //         const provider = new providers.Web3Provider(window.ethereum);
  //         const accounts = await provider.listAccounts();
  //         const network = await provider.getNetwork();
  //         if (network.chainId === 5) {
  //           const { data } = await axios.get(
  //             `https://cicdelement-vdiqmrjkyq-uc.a.run.app/wallet/${accounts[0]}`
  //           );

  //           if (data.success) {
  //             dispatch(addAddress(data.data));
  //             localStorage.setItem("user", JSON.stringify(data.data));
  //           } else {
  //             errorMsg("Something went wrong!");
  //           }
  //         } else {
  //           errorMsg2();
  //         }
  //       } catch (error) {
  //         setError(error);
  //         errorMsg();
  //       }
  //     } else {
  //       setError(new Error("MetaMask is not installed"));
  //     }

  //     setLoading(false);
  //   };
  const { activate, deactivate, account, chainId, library } = useWeb3React();

  const [providerReady, setProviderReady] = useState(false);
  const CoinbaseWallet = new WalletLinkConnector({
    url: `https://mainnet.infura.io/v3/418a01d3ff934d018894cdb3fd3a856e`,
    appName: "DOS_PUNKS",
    supportedChainIds: [1],
  });
  const WalletConnect = new WalletConnectConnector({
    rpcUrl: `https://mainnet.infura.io/v3/418a01d3ff934d018894cdb3fd3a856e`,
    bridge: "https://bridge.walletconnect.org",
    qrcode: true,
  });

  // useEffect(() => {
  //   const saveUser = async () => {
  //     console.log({ chainId });
  //     if (chainId === 5) {
  //       try {
  //         const { data } = await axios.get(
  //           `https://cicdelement-vdiqmrjkyq-uc.a.run.app/wallet/${[account]}`
  //         );
  //         if (data.success) {
  //           dispatch(addAddress(data.data));
  //           localStorage.setItem("user", JSON.stringify(data.data));
  //         } else {
  //           deactivate(CoinbaseWallet);
  //           errorMsg("Something went wrong!");
  //         }
  //       } catch (error) {
  //         (error) => errorMsg(error);
  //       }
  //     } else {
  //       errorMsg2();
  //       deactivate(CoinbaseWallet);
  //     }
  //     setLoading(false);
  //   };
  //   if (account && chainId) saveUser();
  // }, [account, chainId]);

  const coinBaseLogin = async () => {
    setLoading3(true);
    const data = await activate(CoinbaseWallet);
    const pro = await CoinbaseWallet.getProvider();
    console.log({ pro });
    // const provider = await CoinbaseWallet.getAccount();
    // const chainId = await CoinbaseWallet.getChainId();
    // try {
    //   if (chainId === "0x1") {
    //     // const { data } = await axios.get(
    //     //   `https://cicdelement-vdiqmrjkyq-uc.a.run.app/wallet/${provider}`
    //     // );
    //     localStorage.setItem("provider", "coinbase");
    //   } else {
    //     errorMsg2();
    //     deactivate();
    //     localStorage.setItem("provider", undefined);
    //   }
    // } catch (error) {
    //   setError(error);
    //   errorMsg();
    // }

    setLoading3(false);
    setisVisible(false);
  };
  const walletConnect = async () => {
    setLoading2(true);
    WalletConnect.on("session_request", (error, payload) => {
      if (error) {
        // Handle error
        console.error(error);
        errorMsg("Failed to connect to WalletConnect");
      } else {
        // Handle session request
        const { peerMeta } = payload.params[0];
        if (peerMeta && peerMeta.name) {
          console.log(`Session request from ${peerMeta.name}`);
        }
      }
    });
    try {
      await activate(
        WalletConnect,
        (error, payload) => {
          if (error) {
            console.error(error);
            errorMsg("Failed to connect to WalletConnect");
          } else {
            // Handle connection success
          }
        },
        { session_request: true }
      );
      const provider = await WalletConnect.getAccount();
      const chainId = await WalletConnect.getChainId();
      console.log({ chainId });
      if (chainId === 1) {
        localStorage.setItem("provider", "walletConnect");
      } else {
        errorMsg2();
        deactivate();
        localStorage.setItem("provider", undefined);
      }
    } catch (error) {
      if (error) {
        console.error(error);
        setError(error);
        errorMsg("User Denied Access!");
      }
    }

    setLoading2(false);
    setisVisible(false);
  };
  const refreshState = () => {
    window.localStorage.setItem("provider", undefined);
  };

  const disconnect = () => {
    refreshState();
    deactivate();
  };
  return (
    <>
      <Modal
        open={isVisible}
        width={900}
        wrapClassName={theme ? styles.wrapper : dark.wrapper}
        className={theme ? styles.loginModal : dark.loginModal}
        footer={false}
        centered
        onCancel={() => setisVisible(false)}
      >
        <Row gutter={[32, 32]}>
          <Col xs={24} md={8}>
            <h2>Connect Wallet</h2>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
            >
              <h3>Popular</h3>
              <Row
                onClick={ () => {
                    activate(connectors.injected)
                    localStorage.setItem("provider", "injected")
                }}
                style={{
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  color:theme? "#111": "#f0f0f0",
                  background: theme ? "#fff" : "#333",
                  padding: "1rem",
                  borderRadius: "10px",
                  boxShadow: "1px 1px 20px #00000019",
                }}
              >
                <p>MetaMask</p>

                <img
                  style={{ width: 32, height: 32 }}
                  src="https://seeklogo.com/images/M/metamask-logo-09EDE53DBD-seeklogo.com.png"
                />
              </Row>
              <Row
                onClick={walletConnect}
                style={{
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  color:theme? "#111": "#f0f0f0",
                  background: theme ? "#fff" : "#333",
                  padding: "1rem",
                  borderRadius: "10px",
                  boxShadow: "1px 1px 20px #00000019",
                }}
              >
                <p> WalletConnect </p>
                {loading2 && <Spin />}
                <img
                  style={{ width: 32, height: 32 }}
                  src="https://static.opensea.io/logos/walletconnect-alternative.png"
                />
              </Row>
              <Row
                onClick={() =>  {
                    activate(connectors.coinbaseWallet)
                localStorage.setItem("provider", "coinbaseWallet")
                }}
                style={{
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  color:theme? "#111": "#f0f0f0",
                  background: theme ? "#fff" : "#333",
                  padding: "1rem",
                  boxShadow: "1px 1px 20px #00000019",
                  borderRadius: "10px",
                }}
              >
                <p> Coinbase </p>
                {loading3 && <Spin />}
                <img
                  style={{ width: 32, height: 32 }}
                  src="https://static.opensea.io/logos/walletlink-alternative.png"
                />
              </Row>
            </div>
          </Col>
          <Col xs={24} md={4} className={styles.dividerr}>
            <Divider type={"vertical"} style={{ height: "100%" }} />
          </Col>
          <Col xs={24} md={12}>
            <h2>What is a Wallet?</h2>
            <div className={styles.modalRight}>
              <Row>
                <Col xs={4}>
                  <Eth />
                </Col>
                <Col xs={20}>
                  <div>
                    <h4>A Home for your Digital Assets</h4>
                    <p style={{ color: theme ? "#555" : "#999" }}>
                      Wallets are used to send, receive,store, and display
                      digitl assets like Ethereum and NFTs
                    </p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={24} md={4}>
                  <Wallet />
                </Col>
                <Col xs={24} md={20}>
                  <div>
                    <h4>A New Way To Login</h4>
                    <p style={{ color: theme ? "#555" : "#999" }}>
                      Instead of creating new accounts and passwords on every
                      website, just connect your wallet.
                    </p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Button className={theme ? styles.button : dark.button}>
                  Get a Wallet
                </Button>
              </Row>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                  alignItems: "center",
                }}
              >
                <p
                  style={{
                    fontSize: "12px",
                    color: theme ? "#111" : "#999",
                    cursor: "pointer",
                  }}
                >
                  First time setting up a wallet?
                </p>
                <p
                  style={{
                    fontSize: "12px",
                    color: theme ? "#111" : "#999",
                    cursor: "pointer",
                  }}
                >
                  Do you use formatic?
                </p>
              </div>
              <p
                style={{
                  textTransform: "none",
                  fontSize: "11px",
                  color: theme ? "#555" : "#999",
                }}
              >
                By connecting your wallet you agree to the{" "}
                <span
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                >
                  Terms of Service{" "}
                </span>
                and{" "}
                <span
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                >
                  Privacy Notes
                </span>
              </p>
            </div>
          </Col>
        </Row>
      </Modal>
      <Button
        loading={loading}
        onClick={() => setisVisible(true)}
        className={theme ? styles.button : dark.button}
      >
        CONNECT WALLET
      </Button>
    </>
  );
};

export default ConnectWallet;
